import { render } from "./rewardsSection.vue?vue&type=template&id=4536e5a4&scoped=true"
import script from "./rewardsSection.vue?vue&type=script&lang=js"
export * from "./rewardsSection.vue?vue&type=script&lang=js"

import "./rewardsSection.vue?vue&type=style&index=0&id=4536e5a4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4536e5a4"]])

export default __exports__